import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-users-sync-skeleton',
  templateUrl: './users-sync-skeleton.component.html',
  styleUrls: ['./users-sync-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class UsersSyncSkeletonComponent {
  readonly summaryCards = [1, 2, 3, 4];
  readonly detailRows = [1, 2, 3];
  readonly debugCols = [1, 2, 3, 4];
}